// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1wglj","content":"ManualTimeModal_content__8vzVV"};